import React, { useRef } from 'react';
import Image from 'next/image';
import styles from './cursor.module.scss';
import ButtonModel from '../../../models/button';
import CSSFilter from '../../../helpers/css-filter';

type Props = {
  data: ButtonModel;
  children: React.ReactNode;
};

const Cursor = ({ data, children }: Props) => {
  const cursor = useRef<HTMLInputElement>(null);
  const containerRef = useRef<HTMLInputElement>(null);
  const filter = data.icon && data.color.font ? CSSFilter(data.color.font) : {};

  const onMouseMove = (e: any) => {
    if (!cursor || !containerRef || !cursor.current || !containerRef.current)
      return;

    const normalizerX = cursor.current.offsetWidth / 2;
    const normalizerY = cursor.current.offsetHeight / 2;

    const { clientX: x, clientY: y } = e;
    const { top, left } = containerRef.current.getBoundingClientRect() || {};
    cursor.current.style.transform = `translate3d(${
      x - left - normalizerX
    }px, ${y - top - normalizerY}px, 0)`;
  };

  return (
    <div className={styles.cursor} onMouseMove={onMouseMove} ref={containerRef}>
      <div
        className={styles.cursor__cursor}
        ref={cursor}
        style={{
          backgroundColor: data.transparent
            ? 'transparent'
            : data.color.background,
          borderColor: data.color.background,
          height: data.width,
          width: data.width
        }}
      >
        {data?.icon ? (
          <div className={styles.cursor__image} style={filter}>
            <Image
              alt={data.icon.alt}
              src={data.icon.src}
              layout="responsive"
              width={10}
              height={10}
            />
          </div>
        ) : (
          <span
            className={styles.cursor__content}
            style={{ color: data.color.font }}
          >
            {data.text}
          </span>
        )}
      </div>
      {children}
    </div>
  );
};

export default Cursor;
